import React, { useMemo, useState } from 'react';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSnackbar } from 'notistack';
import AddEditMasterAttributes from './AddEditMasterAttributes';
import { useDeleteMasterCustomAttributeMutation } from '../../api/masterAttributes';

const MasterAttributesMenu = ({ Component, row, handleAction }) => {
    const [actionType, setActionType] = useState();
    const { enqueueSnackbar } = useSnackbar();
    const [deleteMasterCustomAttribute] = useDeleteMasterCustomAttributeMutation();

    const handleDelete = async () => {
        setActionType();
        const bodyFormData = new FormData();
        bodyFormData.append('id', row.id);
        try {
            const response = await deleteMasterCustomAttribute(bodyFormData).unwrap();
            if (!response) return;
            if (response?.status === 'ERROR') throw new Error(response?.message);
            enqueueSnackbar('Attribute deleted successfully', {
                variant: 'success',
            });
            handleAction();
        } catch (error) {
            if (error?.statusCode === 400) enqueueSnackbar(error?.data?.message, { variant: 'error' });
            else enqueueSnackbar(error?.message || 'Something went wrong!', { variant: 'error' });
        }
    };

    const dialogContent = useMemo(() => {
        if (actionType === 'modify')
            return {
                title: 'Edit Custom Attribute',
                children: (
                    <AddEditMasterAttributes
                        id={row.id}
                        data={row}
                        handleClose={() => setActionType()}
                        handleAction={handleAction}
                    />
                ),
            };
        if (actionType === 'delete')
            return {
                title: 'Delete Custom Attribute?',
                confirmation: `Are you sure you want to delete this custom attribute?`,
                actions: (
                    <React.Fragment>
                        <Button size="large" onClick={() => setActionType()}>
                            Cancel
                        </Button>
                        <Button size="large" variant="contained" onClick={handleDelete}>
                            Delete
                        </Button>
                    </React.Fragment>
                ),
            };
        return;
    }, [actionType]);

    const actionItems = [
        {
            label: 'Modify',
            type: 'modify',
            icon: <EditIcon />,
            onClick: (action) => setActionType(action.type),
            permissions: ['ROLE_BASE_PERMISSION_SYSTEM_INDEX_UPDATE_MASTER_CUSTOM_ATTRIBUTE'],
        },
        {
            label: 'Delete',
            type: 'delete',
            icon: <DeleteIcon />,
            onClick: (action) => setActionType(action.type),
            permissions: ['ROLE_BASE_PERMISSION_SYSTEM_INDEX_DELETE_MASTER_CUSTOM_ATTRIBUTE'],
        },
    ];

    return <Component actions={actionItems} dialog={dialogContent} onDialogClose={() => setActionType()} />;
};

export default MasterAttributesMenu;
